import React from "react";
import { useNavigate } from "react-router-dom";
import store from "redux/store";
import { Link } from "react-router-dom";
import InputField from "components/fields/InputField";
import Wsywig from "components/fields/Wsywig";
import MultiImageView from "components/fields/MultiImageView";
import FormSelect from "components/fields/FormSelect";
import moment from "moment";
import "moment/locale/nl";
import { SHOW_MODAL_PRODUCT_LOCATION, HIDE_MODAL } from "actions/types";

export function Add({
  initData,
  onSave,
  initCategories,
  validation,
  companyusers,
}) {
  const navigate = useNavigate();
  const [showAllFields, setShowAllFields] = React.useState(true);
  const [showFieldtsTxt, setShowFieldtsTxt] =
    React.useState("Toon alle velden");
  const [showSaveFieldtsTxt, setSaveShowFieldtsTxt] =
    React.useState("Materiaal plaatsen");

  const photoHolder = [];
  const child = React.createRef();

  const [data, setData] = React.useReducer(
    (state, newState) => ({ ...state, ...newState }),
    initData
  );

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    initData[name] = value;
    initData["isDirty"] = true;
    setData({ ...data, [name]: value, ["isDirty"]: true });
    if (validation[name]) {
      validation[name] = null;
    }
  };

  const handleOnChangeCheckBox = (event) => {
    const { name, value } = event.target;
    initData[name] = event.target.checked | 0;
    initData["isDirty"] = true;
    setData({ ...data, [name]: event.target.checked | 0 });
    if (validation[name]) {
      validation[name] = null;
    }
  };

  const handleOnChangeDate = (event) => {
    const name = "available_date";
    initData[name] = moment(event.target.value).format("YYYY-MM-DD");
    setData({
      ...data,
      [name]: moment(event.target.value).format("YYYY-MM-DD"),
    });
    setData({ ...data, ["isDirty"]: true });
    if (validation[name]) {
      validation[name] = null;
    }
  };

  const handleUpload = (files) => {
    setData({ ...data, photos: files });
  };

  const changImage = (file, arrayKey) => {
    initData.product_images[arrayKey] = file;
  };

  const changImages = (files) => {
    initData.product_images = files;
    initData["isDirty"] = true;
  };

  const onSaveWrapped = (event) => {
    event.preventDefault();
    onSave(initData, photoHolder);
  };

  const [key, setKey] = React.useState("stage1");

  const toggleFieldsToShow = (event) => {
    event.preventDefault();
    const newShowAllFields = !showAllFields;
    if (newShowAllFields) {
      setShowFieldtsTxt("Toon minder velden");
      setSaveShowFieldtsTxt("Product opslaan");
    } else {
      setShowFieldtsTxt("Toon alle velden");
      setSaveShowFieldtsTxt("Concept opslaan");
    }
    setShowAllFields(newShowAllFields);
  };

  const onFooterAddImageClick = () => {
    child.current.onClickEvent();
  };

  const mobileBackButtonHandler = (event) => {
    event.preventDefault();
    navigate("/products");
  };

  const addProductLocation = (event) => {
    event.preventDefault();
    event.stopPropagation();
    store.dispatch({
      type: SHOW_MODAL_PRODUCT_LOCATION,
      message: "",
      header: "Product locatie",
      saveEvent: addNewProductLocation,
    });
    return false;
  };

  const addNewProductLocation = (item) => {
    initData.product_location.companyLocation = item;
    initData.product_location.location_id = item.id;
    initData.product_location.location.lat = item.lat;
    initData.product_location.location.lng = item.lng;
    initData.product_location.name = item.address + " " + item.place_name;
    let value = initData.product_location;
    setData({ ...data, ["product_location"]: value, ["isDirty"]: true });
    store.dispatch({ type: HIDE_MODAL });
  };

  if (
    data?.product_location?.id &&
    !initData.product_location.companyLocation
  ) {
    let item = data?.product_location;
    initData.product_location.companyLocation = item;
    initData.product_location.location_id = item.id;
    initData.product_location.location.lat = item.lat;
    initData.product_location.location.lng = item.lng;
    initData.product_location.name = item.address + " " + item.place_name;
    let value = initData.product_location;
    setData({ ...data, ["product_location"]: value, ["isDirty"]: true });
  }

  return (
    <div className="w-full">
      <div className="pb-5 mb-12 border-b border-gray-200">
        <h2 className="font-bold text-gray-900 max-md:mb-3 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
          Advertentie plaatsen
        </h2>
        <p className="mt-2 max-w-4xl text-sm text-gray-500">
          Volg de stappen hieronder om een advertentie te plaatsen.
        </p>
      </div>

      <form onSubmit={onSaveWrapped} className="space-y-12">
        <div className="pb-12 border-b border-gray-900/10">
          <h2 className="font-semibold text-gray-900 text-base/7">
            1. Afbeeldingen toevoegen
          </h2>
          <p className="mt-1 text-gray-600 text-sm/6">
            Hieronder kun je afbeeldingen toevoegen door op het "upload
            afbeelding" kader te klikken. Je kunt maximaal zes afbeeldaingen
            toevoegen.
          </p>
          <div className="mt-10">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
              <MultiImageView
                ref={child}
                files={initData.product_images}
                onChange={changImages}
                isDirty={initData.isDirty}
              />
            </div>
          </div>
        </div>

        <div className="pb-12 border-b border-gray-900/10">
          <h2 className="font-semibold text-gray-900 text-base/7">
            2. Naam & afmetingen
          </h2>
          <p className="mt-1 text-gray-600 text-sm/6">
            Hieronder vul je de naam van het materiaal in. Vervolgens vul je de
            afmetingen van het materiaal in.
          </p>

          <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
            <div className="sm:col-span-6">
              <label
                htmlFor="name"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Advertentietitel
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={initData.name || ""}
                  onChange={handleOnChange}
                  placeholder=""
                  className={`block px-3.5 py-2 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${
                    validation.name ? "border-red-500" : "border-gray-300"
                  }`}
                />
                <p className="mt-1 text-xs text-gray-500">
                  Maak de titel niet langer dan 50 karakters
                </p>
                {validation.name && (
                  <p className="mt-1 text-xs text-red-500">{validation.name}</p>
                )}
              </div>
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="height"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Hoogte
              </label>
              <div className="relative mt-2">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <span className="text-gray-500 sm:text-sm">cm</span>
                </div>
                <input
                  type="number"
                  id="height"
                  name="height"
                  value={initData.height || ""}
                  onChange={handleOnChange}
                  placeholder="Hoogte in cm"
                  className={`block px-3.5 py-2 pl-12 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${
                    validation.height ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {validation.height && (
                  <p className="mt-1 text-xs text-red-500">
                    {validation.height}
                  </p>
                )}
              </div>
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="width"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Breedte
              </label>
              <div className="relative mt-2">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <span className="text-gray-500 sm:text-sm">cm</span>
                </div>
                <input
                  type="number"
                  id="width"
                  name="width"
                  value={initData.width || ""}
                  onChange={handleOnChange}
                  placeholder="Breedte in cm"
                  className={`block px-3.5 py-2 pl-12 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${
                    validation.width ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {validation.width && (
                  <p className="mt-1 text-xs text-red-500">
                    {validation.width}
                  </p>
                )}
              </div>
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="length"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Lengte
              </label>
              <div className="relative mt-2">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <span className="text-gray-500 sm:text-sm">cm</span>
                </div>
                <input
                  type="number"
                  id="length"
                  name="length"
                  value={initData.length || ""}
                  onChange={handleOnChange}
                  placeholder="Lengte in cm"
                  className={`block px-3.5 py-2 pl-12 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${
                    validation.length ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {validation.length && (
                  <p className="mt-1 text-xs text-red-500">
                    {validation.length}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="pb-12 border-b border-gray-900/10">
          <h2 className="font-semibold text-gray-900 text-base/7">
            3. Categorie & prijs
          </h2>
          <p className="mt-1 text-gray-600 text-sm/6">
            Selecteer hieronder in welke categorie het materiaal thuishoort.
            Vervolgens kun je de totaalprijs en het aantal stuks invullen indien
            van toepassing.
          </p>

          <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <label
                htmlFor="categorie_id"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Categorie
              </label>
              <div className="mt-2">
                <FormSelect
                  initData={initCategories}
                  name="categorie_id"
                  onChange={handleOnChange}
                  value={initData.categorie_id}
                  validation={validation}
                  lbl=""
                  emptyOption="Selecteer een categorie"
                  extraClass="h-full"
                />

                {validation.categorie_id && (
                  <p className="mt-1 text-xs text-red-500">
                    {validation.categorie_id}
                  </p>
                )}
              </div>
            </div>

            <div className="sm:col-span-1.5">
              <label
                htmlFor="price"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Prijs
              </label>
              <div className="relative mt-2">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <span className="text-gray-500 sm:text-sm">€</span>
                </div>
                <input
                  type="text"
                  id="price"
                  name="price"
                  value={initData.price || ""}
                  onChange={handleOnChange}
                  className={`block px-3.5 py-2 pl-8 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${
                    validation.price ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {validation.price && (
                  <p className="mt-1 text-xs text-red-500">
                    {validation.price}
                  </p>
                )}
              </div>
            </div>

            <div className="sm:col-span-1.5">
              <label
                htmlFor="amount"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Aantal
              </label>
              <div className="mt-2">
                <input
                  type="number"
                  id="amount"
                  name="amount"
                  value={initData.amount || ""}
                  onChange={handleOnChange}
                  className={`block px-3.5 py-2 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${
                    validation.amount ? "border-red-500" : "border-gray-300"
                  }`}
                />
                {validation.amount && (
                  <p className="mt-1 text-xs text-red-500">
                    {validation.amount}
                  </p>
                )}
              </div>
            </div>
          </div>

          {companyusers && companyusers.length > 1 && (
            <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
              <div className="sm:col-span-3">
                <label
                  htmlFor="extra_user_id"
                  className="block font-medium text-gray-900 text-sm/6"
                >
                  Extra check op product
                </label>
                <div className="mt-2">
                  <select
                    id="extra_user_id"
                    name="extra_user_id"
                    value={initData.extra_user_id || ""}
                    onChange={handleOnChange}
                    className="block px-3.5 py-2 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
                  >
                    <option value="">Geen melding</option>
                    {companyusers.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.full_name}
                      </option>
                    ))}
                  </select>
                  <p className="mt-1 text-xs text-gray-500">
                    Selecteer een gebruiker welke op de hoogte gebracht moet
                    worden bij wijzigingen aan het product.
                  </p>
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="selling_user_id"
                  className="block font-medium text-gray-900 text-sm/6"
                >
                  Meldingen productverkoop
                </label>
                <div className="mt-2">
                  <select
                    id="selling_user_id"
                    name="selling_user_id"
                    value={initData.selling_user_id || ""}
                    onChange={handleOnChange}
                    className="block px-3.5 py-2 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
                  >
                    <option value="">Geen melding</option>
                    {companyusers.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.full_name}
                      </option>
                    ))}
                  </select>
                  <p className="mt-1 text-xs text-gray-500">
                    Selecteer een gebruiker welke op de hoogte gebracht moet
                    worden bij een productreservering.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="pb-12 border-b border-gray-900/10">
          <h2 className="font-semibold text-gray-900 text-base/7">
            4. Omschrijving
          </h2>
          <p className="mt-1 text-gray-600 text-sm/6">
            Hieronder kun je een omschrijving invullen waarbij je belangrijke
            specificaties en/of informatie over het materiaal kan opschrijven.
          </p>

          <div className="mt-10">
            <Wsywig
              value={initData}
              name="description"
              onChange={handleOnChange}
            />
          </div>
        </div>

        <div className="pb-12 border-b border-gray-900/10">
          <h2 className="font-semibold text-gray-900 text-base/7">5. Datum</h2>
          <p className="mt-1 text-gray-600 text-sm/6">
            Hieronder kun je de beschikbaarheidsdatum invullen van het
            materiaal. Daarnaast kun je aangeven of het product bewerkbaar is.
            (Een bewerkbaar product houdt in dat het ontspijkerd, geschuurd etc.
            kan worden).
          </p>

          <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <label
                htmlFor="available_date"
                className="block font-medium text-gray-900 text-sm/6"
              >
                Datum beschikbaar
              </label>
              <div className="mt-2">
                <input
                  type="date"
                  id="available_date"
                  name="available_date"
                  value={initData.available_date || ""}
                  onChange={handleOnChangeDate}
                  className="block px-3.5 py-2 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
                />
              </div>
            </div>

            <div className="flex items-center pt-8 sm:col-span-3">
              <div className="flex relative items-start">
                <div className="flex items-center h-6">
                  <input
                    id="is_editable"
                    name="is_editable"
                    type="checkbox"
                    checked={initData.is_editable}
                    onChange={handleOnChangeCheckBox}
                    className="w-4 h-4 text-indigo-600 rounded border-gray-300 focus:ring-indigo-600"
                  />
                </div>
                <div className="ml-3">
                  <label
                    htmlFor="is_editable"
                    className="text-sm font-medium text-gray-900"
                  >
                    Is product bewerkbaar
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pb-12 border-b border-gray-900/10">
          <h2 className="font-semibold text-gray-900 text-base/7">
            6. Productlocatie
          </h2>
          <p className="mt-1 text-gray-600 text-sm/6">
            Hieronder kun je de locatie selecteren waarop het product afgehaald
            kan worden.
          </p>

          <div className="mt-10">
            <button
              type="button"
              onClick={addProductLocation}
              className="btn-primary"
            >
              Selecteer een locatie
            </button>

            {data.product_location &&
              data.product_location.companyLocation &&
              data.product_location.companyLocation.id > 0 && (
                <p className="mt-4 text-base text-gray-700">
                  {data.product_location.name}
                </p>
              )}

            {data.product_location &&
              !data.product_location.companyLocation &&
              data.product_location?.place_name > 0 && (
                <p className="mt-4 text-base text-gray-700">
                  {data.product_location?.place_name}
                </p>
              )}

            {(!data.product_location ||
              (data.product_location && !data.product_location.id)) &&
              initData.product_location.location.lat > 0 && (
                <p className="mt-4 text-base text-gray-700">
                  {data.product_location.name}
                </p>
              )}

            {initData.product_location.id === 0 && (
              <p className="mt-4 font-bold text-gray-700">
                Geen locatie geselecteerd
              </p>
            )}
          </div>
        </div>

        <div className="flex gap-x-3 justify-end items-center mt-6">
          <button
            type="button"
            onClick={mobileBackButtonHandler}
            className="btn-secondary"
          >
            Annuleren
          </button>
          <button type="submit" className="btn-primary">
            {showSaveFieldtsTxt}
          </button>
        </div>
      </form>
    </div>
  );
}
